export default "__VITE_ASSET__BBphwX20__"